import { React, useState,useEffect } from 'react';
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";

import { CreateDestination,getDestinationById } from '../../services/Destination.service';

import BackIcon from '../../assets/images/back_icon.svg'
import CreateIcon from '../../assets/images/create_icon.svg'
import ArrowleftIcon from "../../assets/images/arrowleft_icon.svg";




const AddDestination = ({ back }) => {

   
    const handleClose = () => {

        resetForm();
        setErrors({});
        back(false)
    }
    const [destionationUserTypes] = useState([{
        name: "Internal",
        value: "I"
    },
    {
        name: "External",
        value: "E"
    }]);
    const [itemDetails, setItemDetails] = useState({});
    // form 

    const { handleBlur, handleChange, handleSubmit, values, errors, touched, resetForm, setErrors, setValues } = useFormik({
        initialValues: {
            name: "shahul",
            active:true,
            userType:"E"
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .max(50, " Name must be at most 50 characters")
                .required("Name is required")
        }),
        onSubmit: async (values, { resetForm }) => {
            try {

                const payload = {
                    // id: "string",
                    name: values.name,
                    shortName: values.shortName,
                    active: true,
                    userType: values.userType
                }
                debugger;

                const res = await CreateDestination(payload)

                if (res?.status === 201) {
                    toast.success(res.data?.message || "Successfully Created")
                    resetForm();
                    setErrors({});
                    back()

                } else {
                    debugger;
                    toast.error(res?.message || res?.detail || res?.data.message);
                }
            } catch (error) {
                if (error?.message) {
                    const msg = error?.message?.split(":")?.[1]?.trim();
                    console.error(msg)


                }
                console.log(error.message);
            }
        },
    });

//     const handleDestinationChange = (event) => {
//     const { value } = event.target;
//     let destinationName1 = '';
//     for (let i = 0; i < destionationUserTypes.length; i++) {

//       if (value == destionationUserTypes[i].value) {

//         destinationName1 = DestinationList[i].name;
//         values.name = destinationName1;
//         break;
//       }
//     }

//     setDestinationName(destinationName1);
//     handleChange(event);
//   };

   

            return (
                <div className='whiteFrame'>
                    <div className="mb_24 displayFlex alignItem_center gap12">
                        <div>
                            <button
                                className="emptyBtn"
                                type="button"
                                onClick={handleClose}
                            >
                                <img src={ArrowleftIcon} alt="ArrowleftIcon" />
                            </button>

                        </div>
                        <div>
                            <h5 className='fontSize20 fontWeight600 blackClr_text'> Add Destination</h5>
                        </div>

                    </div>




                    <form onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className="mb_24 col-md-6">
                                <label
                                    className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                                    htmlFor="fn"
                                >
                                    Name                    </label>
                                <input
                                    className="MainInput"
                                    type="text"
                                    placeholder="Enter Name"
                                    id="name"
                                    name="name"
                                    value={values.name}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                />
                                {errors.name && touched.name ? (
                                    <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                                        {errors.name}
                                    </p>
                                ) : (
                                    <></>
                                )}
                            </div>
                            <div className="mb_24 col-md-6">
                                <label
                                    className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                                    htmlFor="projectId"
                                >
                                    Destination User Type
                                </label>
                                <select
                                    className="selectMainInput"
                                    id="userType"
                                    name="userType"
                                    value={values.userType}
                                    onBlur={handleBlur}
                                     onChange={handleChange}
                                >
                                    <option value="">Select User Type</option>
                                    {destionationUserTypes.map((destination, i) => (
                                        <option key={i} value={destination.value}>
                                            {destination.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.userType && touched.userType ? (
                                    <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                                        {errors.userType}
                                    </p>
                                ) : (
                                    <></>
                                )}
                            </div>

                            <div className="mb_24 col-md-6">
                                <label
                                    className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                                    htmlFor="fn"
                                >
                                    Short Name                    </label>
                                <input
                                    className="MainInput"
                                    type="text"
                                    placeholder="Enter Short Name"
                                    id="shortName"
                                    name="shortName"
                                    value={values.shortName}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                />
                                {errors.shortName && touched.shortName ? (
                                    <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                                        {errors.shortName}
                                    </p>
                                ) : (
                                    <></>
                                )}
                            </div>

                        </div>
                        {/* ========= Submit Button ========= */}
                        {/* <div className='justifyContent_end displayFlex'>
                    <div> */}
                        <button type="submit" className="MainButton cyanSky_clr gap8">
                            <img className='width20px' src={CreateIcon} alt="CreateIcon" />
                            <span>Create Destination</span>
                        </button>
                        {/* </div>
                </div> */}
                    </form>





                </div>
            )
        }

export default AddDestination